
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activate",
      function () {
        return require("private-next-pages/activate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activate"])
      });
    }
  